import React from 'react';
import { Row, Col } from 'components/ui/grid';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Background, Breadcrumb, Card, CardBody } from 'components/ui';
import PageHeaderCorner from 'images/page_header_corner.png';

import './page_header.scss';

const PageHeader = ({ title, titleTag: TitleTag, titleAppend, titlePrepend, description, image, col, children, crumbs, className, ...rest }) => {
  return (
    <Card className={className} {...rest} data-cy="page_header">
      <Background
        image={image}
        className="bg-card"
        style={{
          borderTopRightRadius: '0.375rem',
          borderBottomRightRadius: '0.375rem',
        }}
      />
      <CardBody className="pos-relative">
        <Row>
          <Col {...col}>
            <Breadcrumb crumbs={crumbs} className="mb-1" />
            <Row className="align-center">
              <Col>
                <TitleTag className="mb-0 page-header-title">
                  {titlePrepend && titlePrepend}
                  {title}
                  {titleAppend && titleAppend}
                </TitleTag>
                {description && <p className={classNames('mt-2', { 'mb-0': !children })} dangerouslySetInnerHTML={{ __html: description }} />}
              </Col>
              <Col md="auto">{children}</Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

PageHeader.propTypes = {
  titleTag: PropTypes.string,
  description: PropTypes.string,
  col: PropTypes.shape(Col.propTypes),
  image: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  crumbs: PropTypes.array,
};

PageHeader.defaultProps = {
  col: { lg: 12 },
  image: PageHeaderCorner,
  titleTag: 'h3',
  crumbs: [],
};

export default PageHeader;
